import CarteringOrderEdit from './CarteringOrderEdit';
import WebUniversal, { WUExtendPropsType, initDataType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';
import { Button, Col, Image, DatePicker, Dropdown, Form, MenuProps, Popconfirm, Row, Select, Space, Tooltip, InputNumber } from 'antd';
import getList from '../../universal/getList';
import { useContext, useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import moment from 'moment';
import dayjs from 'dayjs';
import CastOrderDrawe from '../cashier/CastOrderDrawe';
import PayDetails from './PayDetails';
import systematic from '../../../config/systematic';
import OrderBack from './OrderBack';
import { DownOutlined } from '@ant-design/icons';
import RefundDetails from './RefundDetails';
import antMessage from '../../../utils/extend/AntdNotification'
import RefundOrder from './RefundOrder';
import DrawerDetailList from '../cashier/DrawerDetailList';
import systemConfig from '../../../config/systematic';
import { SocketContext } from '../../../App';
import FaPiao from './FaPiao';
import Input from 'antd/es/input/Input';

//组件 
const WebComponents = (props: any) => {
    /** api服务id */
    const apiId = 'cateringOrder';

    const ref = useRef<any>(undefined);

    const [singlePrintData, setSinglePrintData] = useState<any>();
    const [singlePrintOpen, setSinglePrintOpen] = useState<boolean>(false);
    const [castOrderDraweData, setCastOrderDraweData] = useState<any>();
    const [castOrderDraweOpen, setCastOrderDraweOpen] = useState<boolean>(false);
    const [cateringOrderModeId, setCateringOrderModeId] = useState<any>();

    const [caOrderStatus, setCaOrderStatus] = useState<any>();

    const [paymentMethodOpen, setPaymentMethodOpen] = useState<any>();
    const [paymentMethodData, setPaymentMethodData] = useState<any>();


    const [refundOrderOpen, setRefundOrderOpen] = useState<any>();
    const [refundOrderData, setRefundOrderData] = useState<any>();

    const [orderBackOpen, setOrderBackOpen] = useState<any>();
    const [orderBackData, setOrderBackData] = useState<any>();
    // 
    const [orderRefundDetailsOpen, setOrderRefundDetailsOpen] = useState<any>();
    const [orderRefundDetailsData, setOrderRefundDetailsData] = useState<any>();
    /** 后端数据defaultService */
    let defaultService: any = systematic.wmService;
    const [cateringOrderModeData, setCateringOrderModeData] = useState<any>();

    const [caOrderStatusData, setCaOrderStatusData] = useState<any>();
    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;
    const [orderDate, setOrderDate] = useState<any>();
    const [sbId, setSbId] = useState<any>();

    const [sbData, setSbData] = useState<any>();

    const [roomData, setRoomData] = useState<any>();

    const [roomIds, setRoomIds] = useState<Array<any>>();

    const [dataStatusTypeId, setDataStatusTypeId] = useState<any>(1);
    const [dataTypeData, setDataTypeData] = useState<Array<any>>();
    const [form] = Form.useForm();
    const [faPiaoOpen, setFaPiaoOpen] = useState<boolean>(false);
    const [paymentMethodListData, setPaymentMethodListData] = useState<boolean>(false);
    let paymentMethodIds = Form.useWatch("paymentMethodIds", form) as any;
    let realMoney = Form.useWatch("realMoney", form) as any;
    let menuName = Form.useWatch("menuName", form) as any;


    const [faPiaoData, setFaPiaoData] = useState<any>();
    useEffect(() => {
        if (ref.current) {

            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultService = ref.current.defaultService;
        }
        //同步获取数据 async - await
        const fetchData = async () => {
            fetchApi.GET(defaultService,
                {
                    apiId: 'generalData',
                    apiVariable: 'cateringOrderMode@caOrderStatus@dataStatusType',
                    apiExtend: 'showLists'
                }
            ).then(res => {
                if (res.success) {
                    const { cateringOrderMode, caOrderStatus, dataStatusType } = res.data

                    let newDataCateringOrderMode = [{ id: 9999, name: "所有类型" }, ...cateringOrderMode]
                    // let newCaOrderStatus = [{ id: 9999, name: "所有订单" }, ...caOrderStatus]

                    setCateringOrderModeData(newDataCateringOrderMode);
                    setCaOrderStatusData(caOrderStatus);
                    setDataTypeData(dataStatusType)
                }
            })
            await initArgument()
            // setCaOrderStatusData
        };



        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                onRefresh({ branchStoreId: contextData?.currentBranchStoreId })
            }
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    /**
        * 点击触发
        * @param param0 
        */
    const onManageItemsClick = (record: any, { key }: any) => {

        let keyJson = JSON.parse(key);
        const { id, orderId } = keyJson;
        const { closingDate, payId } = record;


        switch (id) {
            //发起退款
            case "refund":
                if (closingDate && moment().format("YYYY-MM-DD") !== moment(closingDate).format("YYYY-MM-DD")) {
                    antMessage("error", '无法发起退款');
                    return false
                }
                // if(caOrderStatus===996) {
                //   
                //     return false
                // }
                openOrderBack(record)
                break;
            //退款详情
            case "refundDetails":
                openRefundDetails(orderId)
                break;
            //支付查询
            case "orderQuery":
                //执行查询操作
                if (!payId) {
                    antMessage("error", '无法发起查询');
                    return false
                }
                fetchApi.GET(wmService, {
                    apiId: "payOrder",
                    apiExtend: "orderQuery",
                    apiData: {
                        payId
                    }
                }).then(res => {
                    if (res.success) {

                        const { trade_state_desc } = res.data.data
                        antMessage('success', '查询成功', trade_state_desc);
                    } else {
                        antMessage('error', '错误，查询失败');
                    }
                }).catch(err => {
                    console.log("err", err);

                    antMessage('error', '错误，查询失败', err.message + ' | status：' + err.errors.status);
                })

                // openRefundDetails(orderId)
                break;
            //整单退款
            // case "refundOrder":
            //     // if(caOrderStatus===996) {
            //     //     antMessage("warning", '该订单交易关闭');
            //     //     return false
            //     // }
            //     openRefundOrder(record)
            //     break
        }

    };
    /** 管理菜单项 */
    const manageItems = (orderId: string) => {
        const items: MenuProps['items'] = [
            {
                label: "发起退款",
                key: '{"orderId":"' + orderId + '","id":"refund"}',
            },
            // {
            //     label: '发起退款(整单)',
            //     key: '{"orderId":"' + orderId + '","id":"refundOrder"}'
            // },
            {
                label: '退款详情',
                key: '{"orderId":"' + orderId + '","id":"refundDetails"}'
            },
            {
                label: '支付查询',
                key: '{"orderId":"' + orderId + '","id":"orderQuery"}'
            },



        ];
        return items;
    };
    /**用户信息项 */
    const userMesItems = (apiData: any) => {
        const { nickName, userName, customerName, callerId } = apiData
        const items: MenuProps['items'] = [
            {
                label: `微信：${nickName}`,
                key: 'nickName',
            },

            {
                label: `用户：${userName}`,
                key: "userName"
            },
            {
                label: `客户：${customerName}`,
                key: "cl"
            },
            {
                label: `手机号码：${callerId}`,
                key: "phone"
            },



        ];
        return items;

    }
    //表头
    const columnsHead = [
        {
            title: '分店',
            dataIndex: 'branchStore',
            render: (text: any) => (text.branchStoreName ? `${text.brandName}${text.branchStoreName}` : "")
        },
        {
            title: '房号',
            dataIndex: 'room',
            render: (text: any) => {
                return <div>{text.roomNum}</div>
            }
        },
        {
            title: '下单',
            dataIndex: 'orderDate',
            render: (text: any) => {
                return <>{moment(text).format("YYYY-MM-DD HH:mm:ss")}</>
            }
        },
        {
            title: '结账',
            dataIndex: 'closingDate',
            render: (text: any) => {
                return <>{text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : ""}</>
            }
        },
        {
            title: '市别',
            dataIndex: 'sb',
            render: (text: any) => {
                return <div>{text.sbName}</div>
            }
        },
        {
            title: '取餐号',
            dataIndex: 'pickupCode',
        },
        {
            title: '餐状态',
            dataIndex: 'pickUpStatus',
            render: (text: any, record: any) => {
                if (record.pickupCode) {
                    switch (text) {
                        case 0:
                            return <Button size='small' type='primary' onClick={() => upDatePickUp({ id: record.id, pickUpStatus: 1 })}>通知取餐</Button>
                        case 1:
                            return <Button size='small' type='primary' onClick={() => upDatePickUp({ id: record.id, pickUpStatus: 2 })}>已取餐</Button>
                        case 2:
                            return <Popconfirm placement={'top'} title="确定要撤销吗(回退到通知取餐)？" onConfirm={() => upDatePickUp({ id: record.id, pickUpStatus: 0 })} okText="确定" cancelText="取消"> <Button danger size='small' >撤销</Button> </Popconfirm>
                    }
                } else {
                    return <></>
                }
            }
        },
        // {
        //     title: '号码',
        //     dataIndex: 'callerId',
        // },
        // {
        //     title: '微信',
        //     dataIndex: 'nickName',
        // },
        // {
        //     title: '用户',
        //     dataIndex: 'userName',
        // },
        {
            title: '人数',
            dataIndex: 'headCount',
        },
        {
            title: '信息',
            dataIndex: 'userMes',
            render: (text: any, record: any) => {
                return <Space size="small">
                    <Dropdown menu={{ items: userMesItems(record) }} trigger={["hover"]}>
                        <Space>
                            <DownOutlined />
                            <div>信息</div>
                        </Space>
                    </Dropdown>
                </Space >
            }

        },

        // {
        //     title: '整单备注',
        //     dataIndex: 'memo',
        // },
        {
            title: '实(应)付',
            dataIndex: 'realMoney',
            render: (text: any, record: any) => {

                let price = (record.caOrderStatus === 999 || record.caOrderStatus === 996) ? text : (record.caOrderStatus === 998 ? record.shouldMoney : 0)
                return <div>{price}{record.caOrderStatus === 999 && record.realMoney !== record.shouldMoney ? <span style={{ color: "red" }}>异常</span> : ""}</div>
            }
        },
        {
            title: '线上支付',
            dataIndex: 'orderPayOnline',
            render: (text: any, record: any) => {
                let isPay = record.isPay;
                let caOrderStatus = record.caOrderStatus;
                let payId = record.payId;
                return isPay && (caOrderStatus === 999 || caOrderStatus === 996) && payId ? <Space size="small">
                    <Dropdown menu={{ items: manageItems(record.id), onClick: (key) => onManageItemsClick(record, key) }} trigger={["hover"]}>
                        <Space>
                            <Button size={"small"} type="dashed" danger >线上支付</Button>
                            <DownOutlined />
                        </Space>
                    </Dropdown>
                </Space > : null
            }

        },
        {
            title: "支付方式",
            dataIndex: "paymentMethod",
            render: (text: any, record: any) => {
                return <Button size="small" type="primary" onClick={() => openPaymentMethod(record.id)}>支付方式</Button>
            }
        },
        {
            title: '打印',
            dataIndex: 'headCount',
            render: (text: any, record: any) => {
                return <Button size="small" type="primary" onClick={() => handleSinglePrint(record)}>打印</Button>
            }
        },
        // {
        //     title: '复制',
        //     dataIndex: 'copy',
        //     render: (text: any, record: any) => {
        //         return <Button size="small" type="primary" onClick={() => copy(record.id)}>复制</Button>
        //     }
        // },
        {
            title: '反结账',
            dataIndex: 'headCount',
            // render: (text: any, record: any) => {
            //     let time = record.closingDate ? record.closingDate : record.orderDate
            //     let endTimeStr = moment(time).format("YYYY-MM-DD") + " " + record.sb.endTime;
            //     let endTime = moment(endTimeStr);
            //     let orderTime = moment();
            //     //比较是否同一天
            //     let isSameDate = false;
            //     if (endTime.format("YYYY-MM-DD") === orderTime.format("YYYY-MM-DD")) isSameDate = true;
            //     //下单时间是否在该天市别的结束时间之前，如果是，则可考虑执行反结账，暂不支持反结账
            //     // let isReverseClosing = orderTime.isBefore(endTime);
            //     return <Button disabled={(record.caOrderStatus === 999 && isSameDate) || record.caOrderStatus === -998 || record.isReverseClosing ? false : true} size="small" type="primary" onClick={() => handleCastOrderDrawe(record)}>反结账</Button>
            //     // return <Button  size="small" type="primary" onClick={() => handleCastOrderDrawe(record)}>反结账</Button>

            // }
            render: (text: any, record: any) => {

                //下单时间是否在该天市别的结束时间之前，如果是，则可考虑执行反结账，暂不支持反结账
                // let isReverseClosing = orderTime.isBefore(endTime);
                return <Button disabled={(record.caOrderStatus === 999) || record.caOrderStatus === -998 || record.isReverseClosing ? false : true} size="small" type="primary" onClick={() => handleCastOrderDrawe(record)}>反结账</Button>
                // return <Button  size="small" type="primary" onClick={() => handleCastOrderDrawe(record)}>反结账</Button>

            }

        },
        {
            title: '订单状态',
            dataIndex: 'caOrderStatusName',
        },
        {
            title: '发票',
            dataIndex: 'branchStore',
            render: (text: any, record: any) => {
                let faPiaoId = record.faPiaoId;
                let returnData;
                returnData = text.isFaPiao ? <Button onClick={() => faPiao(record.id, text.branchStoreId)} size='small'>{faPiaoId ? "已开票" : "未开票"}</Button> : <></>
                return returnData
            }
        },
        // {
        //     title: '复制',
        //     dataIndex: 'copy',
        //     render: (text: any, record: any) => {
        //         return <Button onClick={() => copy(record.id)}>点击</Button>
        //     }
        // },

    ];
    const faPiao = (id: string, branchStoreId: string) => {
        //  closeModal(false);
        setFaPiaoData({ orderId: id, branchStoreId, dataStatusType: dataStatusTypeId });
        setFaPiaoOpen(true)

    }
    const sendWxSubscribeMessage = async (options: any) => {
        let content_json = {};
        const { cur_status, unionId, wxAccountId, serviceId, pickupCode } = options;

        const sendWxMessage = async (options: any) => {
            const { unionId, wxAccountId, serviceId, content_json } = options;
            return await fetchApi.POST(defaultService, {
                apiId: 'message',
                apiExtend: 'send',
                apiData: {
                    messageType: 'wxSubscribeMessageV2',
                    messageWay: 'setUserNotifyUpdate',
                    dataContent: {
                        unionId,
                        wxAccountId,
                        wxSubscribeMessageV2TypeId: 'takeOut',
                        serviceId,
                        content_json
                    }
                }
            });
        };

        switch (cur_status) {
            case 6:
                break;
            default:
                content_json = {
                    cur_status,
                    queue_number: pickupCode,
                };
                sendWxMessage({
                    unionId,
                    wxAccountId,
                    serviceId,
                    content_json
                });
                break;
        }
    };

    const upDatePickUp = (apiData: any) => {
        const { id, pickUpStatus } = apiData;

        fetchApi.POST(defaultService, {
            apiId: 'cateringOrder',
            apiExtend: 'upDatePickUp',
            apiData: {
                id,
                pickUpStatus
            }
        }).then(res => {
            // console.log("res", res);
            if (res.success) {
                const currentData: initDataType = {
                    apiId,
                    sendPageData: { caOrderStatus, menuName, realMoney, paymentMethodIds, cateringOrderModeId, orderDate, sbId, dataStatusType: dataStatusTypeId, roomIds, branchStoreId: contextData?.currentBranchStoreId }
                }
                ref.current.initData(currentData)
                antMessage("success", '成功');

                //根据pickUpStatus状态发送消息
                if (pickUpStatus) {
                    let cur_status: number;
                    switch (pickUpStatus) {
                        case 1:
                            cur_status = 3;

                            fetchApi.GET(defaultService, {
                                apiId: 'cateringOrder',
                                apiExtend: 'checkOrderDetailForSendMessage',
                                apiVariable: id
                            }).then(res => {
                                if (res.success) {
                                    sendWxSubscribeMessage({
                                        cur_status,
                                        unionId: res.data.data.unionId,
                                        wxAccountId: 'wxMiniApp@wisca',
                                        serviceId: id,
                                        pickupCode: res.data.data.pickupCode,
                                    });
                                }
                            })
                            break
                        case 2:
                            cur_status = 4;
                            fetchApi.GET(defaultService, {
                                apiId: 'cateringOrder',
                                apiExtend: 'checkOrderDetailForSendMessage',
                                apiVariable: id
                            }).then(res => {
                                if (res.success) {
                                    fetchApi.PUT(defaultService, {
                                        apiId: 'message',
                                        apiExtend: 'sendV1',
                                        apiData: {
                                            id,
                                            unionId: res.data.data.unionId,
                                            pickupCode: res.data.data.pickupCode
                                        }
                                    }).then(res => {
                                        if (res.success) {
                                            console.log("111111111111");
                                        }
                                    })
                                }
                            })
                            break
                        default:
                            cur_status = 6;
                            break
                    }

                    // fetchApi.GET(defaultService, {
                    //     apiId: 'cateringOrder',
                    //     apiExtend: 'checkOrderDetailForSendMessage',
                    //     apiVariable: id
                    // }).then(res => {
                    //     if (res.success) {
                    //         sendWxSubscribeMessage({
                    //             cur_status,
                    //             unionId: res.data.data.unionId,
                    //             wxAccountId: 'wxMiniApp@wisca',
                    //             serviceId: id,
                    //             pickupCode: res.data.data.pickupCode,
                    //         });
                    //     }
                    // })
                }
            } else {
                antMessage("error", '失败', res.mssage);
            }
        }).catch((err => {
            antMessage("error", '失败', JSON.stringify(err));
        }))
    }

    const initArgument = async () => {
        let sb = await fetchApi.GET(wmService, {
            apiId: "sb",
            apiExtend: 'getBrandStoreIdToSb',
            apiData: {
                branchStoreId: contextData?.currentBranchStoreId
            }
        })

        if (sb.success) {
            setSbData(sb.data)
        }
        fetchApi.GET(wmService,
            {
                apiId: 'room',
                apiExtend: 'showList',
                apiData: {
                    branchStoreId: contextData?.currentBranchStoreId,
                    extendObj: {
                        menuHeadsIdNum: -1,
                        printersIdNum: -1,
                    },
                    mountDataOptions: {
                        userMount: {
                            isDept: true,
                        }
                    },
                }
            }).then(res => {

                if (res.success) {
                    setRoomData(res.data);
                }
            })
    }


    /** 子表头内容 */
    const expandableColumnsHead: Array<any> = [
        {
            title: "品名",
            dataIndex: "menuName",
            render: (text: any, record: any) => {
                
                let caMenuStatus = record.caMenuStatus;
                let coMonStatus = record.coMonStatus;
                let isDerateServiceCharge=record.isDerateServiceCharge;
                let color = ""
                switch (caMenuStatus) {
                    case -998:
                        color = "red"
                        break;
                }
                switch (coMonStatus) {
                    case 2:
                        color = "orange"
                        break
                }
                if(isDerateServiceCharge){
                      color = "blue"
                }


                return <div style={{ color }}>{text}</div>
            }
        },
        // {
        //     title: "id",
        //     dataIndex: "id",
        //     render: (text: any) => <Tooltip placement="topLeft" title={text}>{
        //         (typeof text !== "undefined" && text !== null) ?
        //             (text.length >= 10 ? text.substring(0, 10) + '......' : text)
        //             : ''
        //     }</Tooltip>
        // },

        {
            title: "规格",
            dataIndex: "menuSpecName"
        },
        {
            title: "数量",
            dataIndex: "amount",
        },
        {
            title: "特殊规格",
            dataIndex: "menuSpecSpeName"
        },
        {
            title: "加料",
            dataIndex: "condimentWarehouseName"
        },
        {
            title: "原价",
            dataIndex: "advancePrice",
            render: (text: any, record: any) => {
                return <>{(text)}</>
            }
        },
        {
            title: "折扣",
            dataIndex: "discount",
            render: (text: any, record: any) => {
                return <>{`${text * 10}折`}</>
            }
        },
        {
            title: "折后价",
            dataIndex: "totalPrice",
            render: (text: any, record: any) => {
                return <>{(record.advancePrice * record.discount).toFixed(2)}</>
            }
        },
        {
            title: "实付",
            dataIndex: "purchasePrice",
        },
        {
            title: "备注",
            dataIndex: "memo",
        },
        {
            title: '号码',
            dataIndex: 'callerId',
        },
        {
            title: "微信",
            dataIndex: "nickName",
        },
        {
            title: "用户",
            dataIndex: "userName",
        },
        {
            title: '加菜时间',
            dataIndex: 'sysDate',
            render: (text: any) => {
                return <>{moment(text.createdAt).format("YYYY-MM-DD HH:mm:ss")}</>
            }
        },
        {
            title: '接单时间',
            dataIndex: 'operateTime',
            render: (text: any) => {
                return <>{text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : ""}</>
            }
        },
        {
            title: "菜品状态",
            dataIndex: "caMenuStatusName",
        },

    ]
    //关闭发票选择页面
    const onClosefaPiao = async (status: boolean) => {
        setFaPiaoOpen(false)
        // closeModal(true)

    }
    /** 子表头 */
    const expandableColumns = expandableColumnsHead;

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '餐饮订单',
        apiId,
        columns,
        showStates: true,
        showAdd: false,
        mountDataOptions: {
            "userMount": {
                "isDept": true
            }
        },
        showLogger: {
            logger: { "id": "opLogger" },
            loggerDisplay: true,
            loggerSingleDisplay: true,
            "loggerQueryTypeExtendId": contextData?.currentBranchStoreId,
            isScope: true
        },
        // showEdit: false,
        pagination: true,
        showPageOrderBy: "cateringOrder.orderDate@DESC",
        //子表格
        isExpandable: true,
        isAutoExpandableData: true,
        dataStatusType: dataStatusTypeId,
        expandableColumns,
        expandableDataName: 'cateringOrderDetails',
        EditComponent: CarteringOrderEdit,

        sendPageData: { cateringOrderModeId, dataStatusType: dataStatusTypeId, sbId, orderDate, roomIds, branchStoreId: contextData?.currentBranchStoreId }
    };


    //打开支付详情
    const openPaymentMethod = (id: string) => {
        if (!id) return false;
        setPaymentMethodOpen(true)
        setPaymentMethodData({ id, isModel: true, isAdd: 1, isDelete: 1, isEdit: 1, dataStatusType: dataStatusTypeId })
    }

    //关闭支付详情
    const onClosePaymentMethod = async (status: boolean) => {
        setPaymentMethodOpen(false);
        if (status) {
            const currentData: initDataType = {
                apiId,
                sendPageData: { caOrderStatus, menuName, realMoney, paymentMethodIds, cateringOrderModeId, orderDate, sbId, dataStatusType: dataStatusTypeId, roomIds, branchStoreId: contextData?.currentBranchStoreId }
            }
            ref.current.initData(currentData)
        }
    }


    //打开发起退款详情(菜)
    const openOrderBack = (record: any) => {

        const { id } = record
        if (!id) return false;
        setOrderBackOpen(true)
        setOrderBackData({ orderId: id, roomNum: record.room.roomNum })
    }

    //关闭发起退款详情
    const onCloseOrderBack = async (status: boolean) => {
        setOrderBackOpen(false);
        if (status) {
            const currentData: initDataType = {
                apiId,
                sendPageData: { caOrderStatus, menuName, realMoney, paymentMethodIds, cateringOrderModeId, orderDate, sbId, roomIds, dataStatusType: dataStatusTypeId, branchStoreId: contextData?.currentBranchStoreId }
            }
            ref.current.initData(currentData)
        }
    }



    //打开发起退款详情(整单)
    const openRefundOrder = (record: any) => {

        const { id, realMoney, refundAmount } = record;
        if (!id) return false;
        setRefundOrderOpen(true)
        setRefundOrderData({ orderId: id, realMoney, refundAmount })
    }

    //关闭发起退款详情
    const onCloseRefundOrder = async (status: boolean) => {
        setRefundOrderOpen(false);
        if (status) {
            const currentData: initDataType = {
                apiId,
                sendPageData: { caOrderStatus, menuName, realMoney, paymentMethodIds, cateringOrderModeId, orderDate, sbId, dataStatusType: dataStatusTypeId, roomIds, branchStoreId: contextData?.currentBranchStoreId }
            }
            ref.current.initData(currentData)
        }
    }


    //打开退款详情
    const openRefundDetails = (id: string) => {
        if (!id) return false;
        setOrderRefundDetailsOpen(true)
        setOrderRefundDetailsData({ orderId: id })
    }
    //关闭退款详情
    const onCloseRefundDetails = async (status: boolean) => {
        setOrderRefundDetailsOpen(false);
        if (status) {
            const currentData: initDataType = {
                apiId,
                sendPageData: { caOrderStatus, menuName, realMoney, paymentMethodIds, cateringOrderModeId, orderDate, sbId, dataStatusType: dataStatusTypeId, roomIds, branchStoreId: contextData?.currentBranchStoreId }
            }
            ref.current.initData(currentData)
        }
    }
    /**打开整单打印 */
    const handleSinglePrint = (item: any) => {

        const { id, caOrderStatus } = item
        if (!id) return false

        setSinglePrintOpen(true)
        setSinglePrintData({ id, isIo: true, caOrderStatus, caMenuStatus: [2, 3, 999], dataStatusType: dataStatusTypeId, type: "noPending", roomNum: item.room.roomNum, cateringOrderModeId: [0, 1] })
    }
    //关闭整单打印
    const onCloseSinglePrint = async (status: boolean) => {
        setSinglePrintOpen(false);
        if (status) {
            // setCateringOrderModeData(e);
            const currentData: initDataType = {
                apiId,
                sendPageData: { caOrderStatus, menuName, realMoney, paymentMethodIds, cateringOrderModeId, orderDate, sbId, roomIds, dataStatusType: dataStatusTypeId, branchStoreId: contextData?.currentBranchStoreId }
            }
            ref.current.initData(currentData)
        }
    }
    /** 查看不同模式的订单 */
    const cateringOrderModeChange = (e: any) => {
        setCateringOrderModeId(e)
        // setCateringOrderModeData(e);
        const currentData: initDataType = {
            apiId,
            sendPageData: { caOrderStatus, menuName, paymentMethodIds, realMoney, cateringOrderModeId: e, orderDate, sbId, roomIds, dataStatusType: dataStatusTypeId, branchStoreId: contextData?.currentBranchStoreId }
        }
        ref.current.initData(currentData);
    };

    /** 查看不同状态的订单 */
    const cateringOrderStatusChange = (e: any) => {
        setCaOrderStatus(e)
        const currentData: initDataType = {
            apiId,
            sendPageData: { caOrderStatus: e, menuName, realMoney, paymentMethodIds, cateringOrderModeId, orderDate, sbId, roomIds, dataStatusType: dataStatusTypeId, branchStoreId: contextData?.currentBranchStoreId }
        }
        ref.current.initData(currentData);
    };

    //根据日期回显数据
    const handleDate = (e: any) => {
        let orderDateEx;
        if (e) {
            orderDateEx = dayjs(e).format("YYYY-MM-DD")
            setOrderDate(orderDateEx)

        } else {
            setOrderDate(null)
        }

        const currentData: initDataType = {
            apiId,
            sendPageData: { caOrderStatus, menuName, paymentMethodIds, realMoney, cateringOrderModeId, orderDate: orderDateEx, sbId, roomIds, dataStatusType: dataStatusTypeId, branchStoreId: contextData?.currentBranchStoreId }
        }

        ref.current.initData(currentData);
    }
    /** 查看不同市别的订单 */
    const sbChange = (e: any) => {
        setSbId(e)

        // setCateringOrderModeData(e);
        const currentData: initDataType = {
            apiId,
            sendPageData: { caOrderStatus, menuName, realMoney, paymentMethodIds, cateringOrderModeId, orderDate, sbId: e, dataStatusType: dataStatusTypeId, roomIds, branchStoreId: contextData?.currentBranchStoreId }
        }
        ref.current.initData(currentData);
    };
    const roomChange = (e: any, option: any) => {

        setRoomIds(e)
        const currentData: initDataType = {
            apiId,
            sendPageData: { caOrderStatus, menuName, realMoney, paymentMethodIds, cateringOrderModeId, orderDate, sbId, roomIds: e, dataStatusType: dataStatusTypeId, branchStoreId: contextData?.currentBranchStoreId }
        }
        ref.current.initData(currentData);

    }

    const paymentMethodChange = (e: any) => {
        const currentData: initDataType = {
            apiId,
            sendPageData: { caOrderStatus, menuName, realMoney, paymentMethodIds: e, cateringOrderModeId, orderDate, sbId, roomIds, dataStatusType: dataStatusTypeId, branchStoreId: contextData?.currentBranchStoreId }
        }
        ref.current.initData(currentData);
    }

    /**打开收银订单详情 */
    const handleCastOrderDrawe = (data: any) => {


        setCastOrderDraweOpen(true)
        // setCastOrderDraweData({})
        setCastOrderDraweData({ ...data, mode: "reverseClosing", type: "EDIT", isIo: true, isReverseClosing: true })

    }

    //关闭收银订单详情
    const onCloseCastOrderDraw = async (status: boolean) => {
        setCastOrderDraweOpen(false);
        if (status) {
            const currentData: initDataType = {
                apiId,
                sendPageData: { caOrderStatus, menuName, realMoney, paymentMethodIds, cateringOrderModeId, orderDate, sbId, roomIds, dataStatusType: dataStatusTypeId, branchStoreId: contextData?.currentBranchStoreId }
            }
            ref.current.initData(currentData)
        }
    }
    const dataStatusTypeChange = (e: any, option: any) => {
        setDataStatusTypeId(e)
        const currentData: initDataType = {
            apiId,
            sendPageData: { caOrderStatus, realMoney, menuName, paymentMethodIds, cateringOrderModeId, orderDate, sbId, roomIds, dataStatusType: e, branchStoreId: contextData?.currentBranchStoreId }
        }
        ref.current.initData(currentData);

    }


    const onRefresh = (item: any) => {

        const { branchStoreId } = item
        setSbId(null)
        setRoomIds([])
        form.resetFields(["sbId", "roomIds"])
        const currentData: initDataType = {
            apiId,
            sendPageData: { caOrderStatus, realMoney, menuName, paymentMethodIds, dataStatusType: dataStatusTypeId, cateringOrderModeId, orderDate, sbId: null, roomIds: [], branchStoreId }
        }

        ref.current.initData(currentData);

        setContextData({ ...contextData, refresh: false })
    }
    const onChageRealMoney = (e: any) => {
        let value = e.target.value;
        if (value === "") {
            value = undefined
        } else {
            value = Number(value)
        }

        const currentData: initDataType = {
            apiId,
            sendPageData: { caOrderStatus, paymentMethodIds, menuName, cateringOrderModeId, orderDate, sbId, roomIds, dataStatusType: dataStatusTypeId, realMoney: value, branchStoreId: contextData?.currentBranchStoreId }
        }
        ref.current.initData(currentData);

    }

    const onChageMenuName = (e: any) => {
        let value = e.target.value;
        if (value === "") {
            value = undefined
        } else {
            value = value
        }

        const currentData: initDataType = {
            apiId,
            sendPageData: { caOrderStatus, paymentMethodIds, menuName: value, cateringOrderModeId, orderDate, sbId, roomIds, dataStatusType: dataStatusTypeId, realMoney, branchStoreId: contextData?.currentBranchStoreId }
        }
        ref.current.initData(currentData);

    }
    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ width: "100%" }}>
                    <Form form={form} initialValues={{ dataStatusType: 1 }}>
                        <Row>
                            <Col span={2}>
                                <Form.Item
                                    name="dataStatusType"
                                >
                                    <Select
                                        defaultValue="数据状态"
                                        onChange={dataStatusTypeChange}
                                        placeholder="数据状态"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(dataTypeData)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={2}>

                                <Form.Item
                                    name="bookingDate"
                                >
                                    <DatePicker
                                        allowClear
                                        // defaultValue={moment(data.bookingDate)}
                                        format="YYYY-MM-DD"
                                        onChange={handleDate}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={2}>
                                <Form.Item
                                    name="sbId"
                                >
                                    <Select
                                        showSearch
                                        allowClear
                                        defaultValue="所有市别"
                                        onChange={sbChange}
                                        placeholder="市别"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(sbData, "sbName")}
                                    </Select>
                                </Form.Item>
                            </Col>


                            <Col span={2}>

                                <Form.Item
                                    name="cateringOrderModeId"
                                >
                                    <Select
                                        // showSearch
                                        allowClear
                                        defaultValue="所有模式"
                                        onChange={cateringOrderModeChange}
                                        placeholder="订单模式"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(cateringOrderModeData)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={3}>

                                <Form.Item
                                    name="roomIds"
                                >
                                    <Select
                                        allowClear
                                        // style={{ width: "300px" }}
                                        onChange={roomChange}
                                        // orderTypeData
                                        mode="multiple"
                                        showSearch
                                        placeholder="请选择房间!"
                                        optionFilterProp="children"
                                        onSearch={(e) => getList.search('room', setRoomData, e, {
                                            andWhereObj: {
                                                branchStoreId: contextData?.currentBranchStoreId, extendObj: {
                                                    menuHeadsIdNum: -1,
                                                    printersIdNum: -1,
                                                }
                                            }
                                        })}
                                        filterOption={(input, option: any) => {
                                            return true
                                        }}
                                    >
                                        {getList.general(roomData, 'roomNum')}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={3}>
                                <Form.Item
                                    name="caOrderStatus"
                                >
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        // defaultValue="所有订单"
                                        onChange={cateringOrderStatusChange}
                                        placeholder="订单状态"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(caOrderStatusData)}
                                    </Select>
                                </Form.Item>
                            </Col>



                            <Col span={3}>

                                <Form.Item
                                    name="paymentMethodIds"
                                >
                                    <Select
                                        allowClear
                                        // style={{ width: "300px" }}
                                        onChange={paymentMethodChange}
                                        // orderTypeData
                                        mode="multiple"
                                        showSearch
                                        placeholder="支付方式!"
                                        optionFilterProp="children"
                                        onSearch={(e) => getList.search('paymentMethod', setPaymentMethodListData, e)}
                                        filterOption={(input, option: any) => {
                                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}
                                    >
                                        {getList.general(paymentMethodListData, 'paymentMethodName')}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={3}>

                                <Form.Item
                                    label="金额"
                                    name="realMoney"
                                >
                                    <InputNumber onKeyDown={(e: any) => {
                                        console.log("e", e);

                                        if (e.key === 'Enter') {
                                            onChageRealMoney(e)
                                        }

                                    }} placeholder="按回车" />
                                </Form.Item>
                            </Col>

                            <Col span={2}>

                                <Form.Item
                                    label="菜名"
                                    name="menuName"
                                >
                                    <Input onKeyDown={(e: any) => {

                                        if (e.key === 'Enter') {
                                            onChageMenuName(e)
                                        }

                                    }} placeholder="按回车" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>


                </div>

            </div>


            <WebUniversal props={extendProps} ref={ref} />

            {/**整单打印 */}
            {/* {singlePrintOpen ? (<SinglePrint data={singlePrintData} closeModal={onCloseSinglePrint}
            />)
                : null} */}

            {singlePrintOpen ? (<DrawerDetailList data={singlePrintData} closeModal={onCloseSinglePrint}
            />)
                : null}

            {/**收银订单详情 */}
            {
                castOrderDraweOpen ? (<CastOrderDrawe data={castOrderDraweData} closeModal={onCloseCastOrderDraw}
                />)
                    : null
            }
            {/**订单支付详情 */}
            {
                paymentMethodOpen ? (<PayDetails data={paymentMethodData} closeModal={onClosePaymentMethod}
                />)
                    : null
            }

            {/**发起退款详情 */}
            {
                orderBackOpen ? (<OrderBack data={orderBackData} closeModal={onCloseOrderBack}
                />)
                    : null
            }

            {/**退款详情 */}
            {
                orderRefundDetailsOpen ? (<RefundDetails data={orderRefundDetailsData} closeModal={onCloseRefundDetails}
                />)
                    : null
            }
            {/**发起退款(整单) */}
            {
                refundOrderOpen ? (<RefundOrder data={refundOrderData} closeModal={onCloseRefundOrder}
                />)
                    : null
            }
            {/**发票页面 */}
            {faPiaoOpen ? (<FaPiao data={faPiaoData} closeModal={onClosefaPiao} />) : null}

        </>
    )
}

export default WebComponents;
